import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from 'components/app/dashboard';
import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import Login from '../components/app/login/Login';
import Process from '../components/app/process/process-list/Process';
import ProcessDetails from '../components/app/process/process-details/ProcessDetails';
import { DashboardProvider } from 'components/app/dashboard/DashboardContext';
import ExportDemonstrative from 'components/app/importacao/ExportDemonstrative';
import NovaSenha from '../components/app/recovery-pass'
import Contacts from '../components/app/contacts'
import Drawback from 'components/app/drawback';


const FalconRoutes = () => {
  return (
    <DashboardProvider>
      <Routes>
        <Route element={<AuthSimpleLayout />}>
          <Route path="/" element={<Login />} />
        </Route>
        <Route path="/new_password/:token" element={<NovaSenha />} />
        <Route element={<MainLayout />}>
          {/*Dashboard*/}
          <Route path="/app/dashboard" element={<Dashboard />} />
          <Route path="/app/process/process-list" element={<Process />} />
          <Route
            path="/app/process/process-details/:id"
            element={<ProcessDetails />}
          />
           {/* <Route path="/app/drawback" element={<Drawback />} /> */}
          <Route path="/app/contacts" element={<Contacts />} />
        </Route>
        <Route path="/app/importacao" element={<ExportDemonstrative />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </DashboardProvider>
  );
};

export default FalconRoutes;
